import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/componentes/ui/card';
import { useAuth } from '@/lib/auth';

/**
 * `/` — a primeira tela de quem entra.
 *
 * Enquanto a plataforma é só usuários e permissões, não há indicador nem fila para mostrar aqui, e
 * um painel com cartões vazios e números zerados seria pior que uma tela honesta. Então esta página
 * faz duas coisas: cumprimenta quem entrou e diz onde está o trabalho da iteração atual.
 *
 * Quando os módulos de clientes, bancos e propostas existirem, é aqui que entram os cartões —
 * cada um lendo de `GET` próprio via TanStack Query, com o loader da marca no lugar do número
 * enquanto carrega (docs/CONVENCOES-UI.md, §Estados de tela).
 */
export function PaginaInicio() {
  const { usuario } = useAuth();
  const primeiroNome = usuario?.nome.trim().split(/\s+/)[0] ?? '';

  return (
    <div className="mx-auto w-full max-w-3xl space-y-6">
      <div className="space-y-1">
        {/*
          Saudação **neutra**: a partir da 1.6 esta tela é a primeira que o convidado vê, e o cadastro
          guarda o nome da pessoa, não o gênero dela. "Bem-vinda" acertava a sócia e errava metade da
          equipe que ainda vai entrar.
        */}
        <h1 className="text-3xl">{primeiroNome ? `Olá, ${primeiroNome}.` : 'Olá.'}</h1>
        <p className="text-sm text-muted-foreground">
          Este é o painel interno da Tríplice Capital.
        </p>
      </div>

      <Card>
        <CardHeader>
          <CardTitle>Plataforma em construção</CardTitle>
          <CardDescription>
            A primeira entrega é o controle de acesso: usuários, papéis e permissões.
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-2 text-sm text-muted-foreground">
          <p>
            Clientes, bancos, propostas e documentos vêm depois, cada um como um módulo próprio. Os
            itens de administração já aparecem no menu, desabilitados, com o motivo à vista.
          </p>
          <p>
            Seu acesso é definido por <strong className="text-foreground">permissões</strong>, não
            por cargo: tudo começa negado e o administrador concede o que você precisa. A lista do
            que você pode fazer está em <strong className="text-foreground">Meu perfil</strong>.
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
